import React, { useEffect, useState } from 'react';
import Project from './Project';


const Portfolio = () => {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    fetch('database.json')
      .then((res) => res.json())
      .then((data) => setSites(data));
  }, []);
  return (
    <div id="portfolio" className="mx-12 py-16">
      <h2 className='text-3xl text-center font-bold my-4'>Portfolio</h2>

      <div className='grid sm:grid-cols-1 lg:grid-cols-4 gap-8 my-5'>
        {
          sites.map(project => <Project key={project._id} project={project}></Project>)
        }
      </div>
    </div>
  );
};

export default Portfolio;
